module.exports = __webpack_public_path__ + "static/img/Video-Medium.7df2e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Video-Medium.png
// module id = DvDL
// module chunks = 1